import * as Sentry from '@sentry/vue';

class ErrorReportingService {
  initialized = false;

  setConfigParams({ app, env, dsn, sessionReplayRate }) {
    this.initialized = true;
    Sentry.init({
      app,
      dsn,
      environment: env,
      integrations: [Sentry.replayIntegration({ blockAllMedia: true, maskAllInputs: true, maskAllText: false, mask: ['.sentry-masked-text'] })],
      replaysSessionSampleRate: sessionReplayRate,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  reportError(err) {
    if (this.initialized) {
      Sentry.captureException(err);
    } else {
      console.log('[ErrorReportingService]', err);
    }
  }

  captureMessage(message, attributes = {}) {
    if (this.initialized) {
      Sentry.captureMessage(message, {
        extra: attributes,
      });
    } else {
      console.log('[ErrorReportingService] message:', message, attributes);
    }
  }
}

export default new ErrorReportingService();
